import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceDetail from '../components/ServiceDetail';
import dqmImage from '../assets/DQM.png';
import './DataQuality.css';

const DataQuality = () => {
  const { t } = useTranslation();
  const serviceData = t('serviceContent.dataQuality', { returnObjects: true });

  return (
    <div className="data-quality-page">
      <ServiceDetail serviceData={serviceData} serviceImage={dqmImage} serviceKey="dataQuality" />
    </div>
  );
};

export default DataQuality;



